import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _32c39f03 = () => interopDefault(import('../../../pages/active-devices/index.vue' /* webpackChunkName: "pages/active-devices/index" */))
const _5b544578 = () => interopDefault(import('../../../pages/alerts/index.vue' /* webpackChunkName: "pages/alerts/index" */))
const _3bea3a1f = () => interopDefault(import('../../../pages/as/index.vue' /* webpackChunkName: "pages/as/index" */))
const _8be6e2c6 = () => interopDefault(import('../../../pages/audit-trail/index.vue' /* webpackChunkName: "pages/audit-trail/index" */))
const _d7b83e96 = () => interopDefault(import('../../../pages/change-logs/index.vue' /* webpackChunkName: "pages/change-logs/index" */))
const _d18c6df6 = () => interopDefault(import('../../../pages/combined-report/index.vue' /* webpackChunkName: "pages/combined-report/index" */))
const _6c0e61de = () => interopDefault(import('../../../pages/dev/index.vue' /* webpackChunkName: "pages/dev/index" */))
const _37296ece = () => interopDefault(import('../../../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _02e8fdc3 = () => interopDefault(import('../../../pages/group-monitoring/index.vue' /* webpackChunkName: "pages/group-monitoring/index" */))
const _01524a84 = () => interopDefault(import('../../../pages/hub/index.vue' /* webpackChunkName: "pages/hub/index" */))
const _c32d6ba8 = () => interopDefault(import('../../../pages/loggers/index.vue' /* webpackChunkName: "pages/loggers/index" */))
const _cad79e9c = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _61474964 = () => interopDefault(import('../../../pages/measurements/index.vue' /* webpackChunkName: "pages/measurements/index" */))
const _237df571 = () => interopDefault(import('../../../pages/notifications/index.vue' /* webpackChunkName: "pages/notifications/index" */))
const _cf9aedc6 = () => interopDefault(import('../../../pages/objects/index.vue' /* webpackChunkName: "pages/objects/index" */))
const _b9c0e140 = () => interopDefault(import('../../../pages/organization/index.vue' /* webpackChunkName: "pages/organization/index" */))
const _673c7320 = () => interopDefault(import('../../../pages/password-expired/index.vue' /* webpackChunkName: "pages/password-expired/index" */))
const _08b8e82e = () => interopDefault(import('../../../pages/qr-report/index.vue' /* webpackChunkName: "pages/qr-report/index" */))
const _16617c08 = () => interopDefault(import('../../../pages/reports/index.vue' /* webpackChunkName: "pages/reports/index" */))
const _27f8b706 = () => interopDefault(import('../../../pages/roles/index.vue' /* webpackChunkName: "pages/roles/index" */))
const _46d1bc21 = () => interopDefault(import('../../../pages/schedule-plans/index.vue' /* webpackChunkName: "pages/schedule-plans/index" */))
const _25694657 = () => interopDefault(import('../../../pages/subscribed-devices/index.vue' /* webpackChunkName: "pages/subscribed-devices/index" */))
const _c91b56de = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _7a0db499 = () => interopDefault(import('../../../pages/zone/index.vue' /* webpackChunkName: "pages/zone/index" */))
const _666b2e66 = () => interopDefault(import('../../../pages/active-devices/ActiveDevicesChart.vue' /* webpackChunkName: "pages/active-devices/ActiveDevicesChart" */))
const _0a0e2034 = () => interopDefault(import('../../../pages/alerts/details.vue' /* webpackChunkName: "pages/alerts/details" */))
const _5ffeb24f = () => interopDefault(import('../../../pages/as/details.vue' /* webpackChunkName: "pages/as/details" */))
const _4028466a = () => interopDefault(import('../../../pages/forgot-password/reset.vue' /* webpackChunkName: "pages/forgot-password/reset" */))
const _625b1cf3 = () => interopDefault(import('../../../pages/group-monitoring/details.vue' /* webpackChunkName: "pages/group-monitoring/details" */))
const _572392c0 = () => interopDefault(import('../../../pages/hub/gps-history/index.vue' /* webpackChunkName: "pages/hub/gps-history/index" */))
const _02590cac = () => interopDefault(import('../../../pages/hub/settings/index.vue' /* webpackChunkName: "pages/hub/settings/index" */))
const _8da72280 = () => interopDefault(import('../../../pages/hub/status-history/index.vue' /* webpackChunkName: "pages/hub/status-history/index" */))
const _1ef9f31c = () => interopDefault(import('../../../pages/loggers/details.vue' /* webpackChunkName: "pages/loggers/details" */))
const _3488d100 = () => interopDefault(import('../../../pages/measurements/nfc/index.vue' /* webpackChunkName: "pages/measurements/nfc/index" */))
const _80fcf9d6 = () => interopDefault(import('../../../pages/measurements/rf/index.vue' /* webpackChunkName: "pages/measurements/rf/index" */))
const _69218c66 = () => interopDefault(import('../../../pages/objects/details.vue' /* webpackChunkName: "pages/objects/details" */))
const _61988960 = () => interopDefault(import('../../../pages/organization/details.vue' /* webpackChunkName: "pages/organization/details" */))
const _4f0dbbd1 = () => interopDefault(import('../../../pages/schedule-plans/details.vue' /* webpackChunkName: "pages/schedule-plans/details" */))
const _042c0f7e = () => interopDefault(import('../../../pages/users/details.vue' /* webpackChunkName: "pages/users/details" */))
const _46de5a79 = () => interopDefault(import('../../../pages/users/invitations.vue' /* webpackChunkName: "pages/users/invitations" */))
const _29e95337 = () => interopDefault(import('../../../pages/hub/gps-history/hubGPSChart.vue' /* webpackChunkName: "pages/hub/gps-history/hubGPSChart" */))
const _55223f27 = () => interopDefault(import('../../../pages/hub/gps-history/hubGPSTable.vue' /* webpackChunkName: "pages/hub/gps-history/hubGPSTable" */))
const _0d963b1a = () => interopDefault(import('../../../pages/hub/settings/details.vue' /* webpackChunkName: "pages/hub/settings/details" */))
const _f7c86db2 = () => interopDefault(import('../../../pages/hub/status-history/chartFramesCnt.vue' /* webpackChunkName: "pages/hub/status-history/chartFramesCnt" */))
const _b619f2ca = () => interopDefault(import('../../../pages/hub/status-history/chartPowerStatus.vue' /* webpackChunkName: "pages/hub/status-history/chartPowerStatus" */))
const _94d0e794 = () => interopDefault(import('../../../pages/hub/status-history/report.vue' /* webpackChunkName: "pages/hub/status-history/report" */))
const _2ddb5e33 = () => interopDefault(import('../../../pages/login/sso/completedata.vue' /* webpackChunkName: "pages/login/sso/completedata" */))
const _28461e53 = () => interopDefault(import('../../../pages/login/sso/linkaccount.vue' /* webpackChunkName: "pages/login/sso/linkaccount" */))
const _b4711c14 = () => interopDefault(import('../../../pages/measurements/nfc/report.vue' /* webpackChunkName: "pages/measurements/nfc/report" */))
const _cf5a987e = () => interopDefault(import('../../../pages/measurements/rf/grouping-report.vue' /* webpackChunkName: "pages/measurements/rf/grouping-report" */))
const _79e50281 = () => interopDefault(import('../../../pages/measurements/rf/report.vue' /* webpackChunkName: "pages/measurements/rf/report" */))
const _95ae5da0 = () => interopDefault(import('../../../pages/users/new/organizations.vue' /* webpackChunkName: "pages/users/new/organizations" */))
const _2dfb1658 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/active-devices",
    component: _32c39f03,
    name: "active-devices"
  }, {
    path: "/alerts",
    component: _5b544578,
    name: "alerts"
  }, {
    path: "/as",
    component: _3bea3a1f,
    name: "as"
  }, {
    path: "/audit-trail",
    component: _8be6e2c6,
    name: "audit-trail"
  }, {
    path: "/change-logs",
    component: _d7b83e96,
    name: "change-logs"
  }, {
    path: "/combined-report",
    component: _d18c6df6,
    name: "combined-report"
  }, {
    path: "/dev",
    component: _6c0e61de,
    name: "dev"
  }, {
    path: "/forgot-password",
    component: _37296ece,
    name: "forgot-password"
  }, {
    path: "/group-monitoring",
    component: _02e8fdc3,
    name: "group-monitoring"
  }, {
    path: "/hub",
    component: _01524a84,
    name: "hub"
  }, {
    path: "/loggers",
    component: _c32d6ba8,
    name: "loggers"
  }, {
    path: "/login",
    component: _cad79e9c,
    name: "login"
  }, {
    path: "/measurements",
    component: _61474964,
    name: "measurements"
  }, {
    path: "/notifications",
    component: _237df571,
    name: "notifications"
  }, {
    path: "/objects",
    component: _cf9aedc6,
    name: "objects"
  }, {
    path: "/organization",
    component: _b9c0e140,
    name: "organization"
  }, {
    path: "/password-expired",
    component: _673c7320,
    name: "password-expired"
  }, {
    path: "/qr-report",
    component: _08b8e82e,
    name: "qr-report"
  }, {
    path: "/reports",
    component: _16617c08,
    name: "reports"
  }, {
    path: "/roles",
    component: _27f8b706,
    name: "roles"
  }, {
    path: "/schedule-plans",
    component: _46d1bc21,
    name: "schedule-plans"
  }, {
    path: "/subscribed-devices",
    component: _25694657,
    name: "subscribed-devices"
  }, {
    path: "/users",
    component: _c91b56de,
    name: "users"
  }, {
    path: "/zone",
    component: _7a0db499,
    name: "zone"
  }, {
    path: "/active-devices/ActiveDevicesChart",
    component: _666b2e66,
    name: "active-devices-ActiveDevicesChart"
  }, {
    path: "/alerts/details",
    component: _0a0e2034,
    name: "alerts-details"
  }, {
    path: "/as/details",
    component: _5ffeb24f,
    name: "as-details"
  }, {
    path: "/forgot-password/reset",
    component: _4028466a,
    name: "forgot-password-reset"
  }, {
    path: "/group-monitoring/details",
    component: _625b1cf3,
    name: "group-monitoring-details"
  }, {
    path: "/hub/gps-history",
    component: _572392c0,
    name: "hub-gps-history"
  }, {
    path: "/hub/settings",
    component: _02590cac,
    name: "hub-settings"
  }, {
    path: "/hub/status-history",
    component: _8da72280,
    name: "hub-status-history"
  }, {
    path: "/loggers/details",
    component: _1ef9f31c,
    name: "loggers-details"
  }, {
    path: "/measurements/nfc",
    component: _3488d100,
    name: "measurements-nfc"
  }, {
    path: "/measurements/rf",
    component: _80fcf9d6,
    name: "measurements-rf"
  }, {
    path: "/objects/details",
    component: _69218c66,
    name: "objects-details"
  }, {
    path: "/organization/details",
    component: _61988960,
    name: "organization-details"
  }, {
    path: "/schedule-plans/details",
    component: _4f0dbbd1,
    name: "schedule-plans-details"
  }, {
    path: "/users/details",
    component: _042c0f7e,
    name: "users-details"
  }, {
    path: "/users/invitations",
    component: _46de5a79,
    name: "users-invitations"
  }, {
    path: "/hub/gps-history/hubGPSChart",
    component: _29e95337,
    name: "hub-gps-history-hubGPSChart"
  }, {
    path: "/hub/gps-history/hubGPSTable",
    component: _55223f27,
    name: "hub-gps-history-hubGPSTable"
  }, {
    path: "/hub/settings/details",
    component: _0d963b1a,
    name: "hub-settings-details"
  }, {
    path: "/hub/status-history/chartFramesCnt",
    component: _f7c86db2,
    name: "hub-status-history-chartFramesCnt"
  }, {
    path: "/hub/status-history/chartPowerStatus",
    component: _b619f2ca,
    name: "hub-status-history-chartPowerStatus"
  }, {
    path: "/hub/status-history/report",
    component: _94d0e794,
    name: "hub-status-history-report"
  }, {
    path: "/login/sso/completedata",
    component: _2ddb5e33,
    name: "login-sso-completedata"
  }, {
    path: "/login/sso/linkaccount",
    component: _28461e53,
    name: "login-sso-linkaccount"
  }, {
    path: "/measurements/nfc/report",
    component: _b4711c14,
    name: "measurements-nfc-report"
  }, {
    path: "/measurements/rf/grouping-report",
    component: _cf5a987e,
    name: "measurements-rf-grouping-report"
  }, {
    path: "/measurements/rf/report",
    component: _79e50281,
    name: "measurements-rf-report"
  }, {
    path: "/users/new/organizations",
    component: _95ae5da0,
    name: "users-new-organizations"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
